import React from 'react';
import styled from 'astroturf/react';
import _Container from "Spinner-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/CreateSocialItem/Spinner.tsx?styleId=Container";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

export type SpinnerProps = {
  size?: number;
  blue?: boolean;
};

export const Spinner: React.FC<SpinnerProps> = ({ size = 28, blue }) => {
  return <Container blue={blue} style={{ width: size, height: size }} />;
};
